'use client';

import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectItemProps,
} from '@sola/ark-core/molecules/select/select.js';

import {
  ArticleLimitEnum,
  ArticleSortByEnum,
  useArticleQueryParams,
  usePaginationQueryParams,
} from '../../utils/query-params';

const showNumArticlesValues: SelectItemProps[] = ArticleLimitEnum.options.map(
  (limit) => ({
    value: limit.toString(),
  }),
);

export const ArticleFilter = ({
  articleCount,
  limit,
}: {
  articleCount?: number;
  limit?: number;
}) => {
  const { t } = useTranslation();

  const sortByItems: SelectItemProps[] = [
    {
      text: t('skippy.article.sort.featured'),
      value: ArticleSortByEnum.enum.promotedContent,
    },
    {
      text: t('skippy.article.sort.newest'),
      value: ArticleSortByEnum.enum.desc,
    },
    {
      text: t('skippy.article.sort.oldest'),
      value: ArticleSortByEnum.enum.asc,
    },
  ];

  const { articleFilters, setArticleFilters } = useArticleQueryParams({
    perPage: limit,
  });
  const { setCurrentPageWithoutScroll } = usePaginationQueryParams();

  const handlePerPageChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setArticleFilters((prev) => ({
      ...prev,
      limit: Number(e.target.value),
    }));
    setCurrentPageWithoutScroll(0);
  };

  const handleSortByChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setArticleFilters((prev) => ({
      ...prev,
      sortby: e.target.value as ArticleSortByEnum,
    }));
  };

  return (
    <div className="ArticleFilter">
      <div className="ArticleFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">
        <div className="body-md md:align-center">
          {articleCount === undefined
            ? undefined
            : t(`skippy.article.resultWithCount`, {
                count: articleCount,
              })}
        </div>
        <div className="flex align-end md:justify-end md:align-center gap-comfy-sm">
          <Select
            onChange={(e) => handleSortByChange(e)}
            value={articleFilters.sortby}
            name="sort"
            items={sortByItems}
            aria-label={t('skippy.article.sortArticlesBy')}
          />
          <Select
            onChange={(e) => handlePerPageChange(e)}
            value={articleFilters.limit}
            name="visibleArticles"
            items={showNumArticlesValues}
            aria-label={t('skippy.article.numberOfArticles')}
          />
        </div>
      </div>
    </div>
  );
};
